import { css, CSSObject, type Interpolation, type Theme } from '@emotion/react';
import { CSSProperties } from 'react';

import { appConfig } from 'src/app';

import { theme } from './theme';

const getFontSrc = (fileName: string) =>
    ['woff2', 'woff']
        .map(
            (variant) =>
                `url('${appConfig.assetsUrl}/fonts/${fileName}.${variant}') format('${variant}')`
        )
        .join(',');

const getFontFace = (
    fontFamily: string,
    fontWeight: CSSProperties['fontWeight'],
    fileName: string
): CSSObject => ({
    '@font-face': {
        fontFamily,
        src: getFontSrc(fileName),
        fontWeight,
        fontStyle: 'normal',
        fontDisplay: 'swap',
    },
});

export const globalStyles: Interpolation<Theme> = css([
    {
        'body, html': {
            scrollBehavior: 'smooth',
            height: '100%',
        },

        '#root': {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
    },
    getFontFace('Radikal', theme.typography.fontWeightLight, 'nootype_-_radikal-light'),
    getFontFace('Radikal', theme.typography.fontWeightBold, 'nootype_-_radikal-bold-webfont'),
    getFontFace('Radikal', theme.typography.fontWeightBold, 'RadikalBoldItalic'),
    getFontFace(
        'Trade Gothic LT Std',
        theme.typography.fontWeightBold,
        'trade-gothic-linotype-standard-bold'
    ),
    getFontFace(
        'Trade Gothic LT Std',
        theme.typography.fontWeightBold,
        'trade-gothic-condensed-bold'
    ),
    getFontFace('Apercu Mono', theme.typography.fontWeightRegular, 'ApercuMono'),
    getFontFace('Helvetica Neue', theme.typography.fontWeightRegular, 'NeueHelvetica'),
    getFontFace('T1 Korium', theme.typography.fontWeightRegular, 'T1Korium'),
]);
